import {createSlice} from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "project",
  initialState: {
    list: [],
    count: 0,
    selectedProject: null,
  },

  reducers: {
    setOwnersByProject: (state, {payload: list}) => {
      return {
        ...state,
        list,
      };
    },
    countOwnersByProject: (state, {payload: count}) => {
      return {
        ...state,
        count,
      };
    },
    setSelectedProject: (state, {payload: projectId}) => {
      return {
        ...state,
        selectedProject: projectId,
      };
    },
  },
});

export const {setOwnersByProject, countOwnersByProject, setSelectedProject} =
  slice.actions;

export default slice.reducer;

export const getsetOwnersByProjectSelector = (store) => store.project.list;
export const getOwnersByProjectCountSelector = (store) => store.project.count;
export const getSelectedProjectSelector = (store) =>
  store.project.selectedProject;
